export default function Data_Distribution() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Data_Distribution</h1>
      <p>Content for Data_Distribution goes here.</p>
    </div>
  );
}